import { EntityInterface } from '../entity/interfaces/entityInterface.model';

export class ClipboardObject {

    public type: string;
    public entities: Array<EntityInterface>;

    constructor() {
    }

}
